<template>
    <div >
      <b-modal 
        id="PrePrintedMARSRep" 
        size="md" 
        centered 
        :title="'Pre-Printed Patient MARS'" 
        :visible="true"
        :no-close-on-backdrop="true" 
        @ok="onClickShowReport" 
        @cancel="onClickClose"
        @close="onClickClose">
        <b-row>
          <b-col lg="12" md="12" sm="12">
            <MdSelect
            v-bind:Label="$tc('Shared.Patient',2)"
            v-bind:Options="PatientsList"
            v-bind:Model="PatientCodeModel"
            v-bind:FieldDescription="'patientName'"
            v-bind:FieldCode="'patientcode'"
            v-bind:Multiple="true"             
            :Input="ChangeDropDownPatients"
            :CustomLabel="customLabelPatients"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12">
          <MdSelect
            v-bind:Label="$tc('Shared.Program',2)"
            v-bind:Options="ProgramList"
            v-bind:FieldDescription="'name'"
            v-bind:FieldCode="'code'"
            v-bind:Multiple="true"
            v-bind:Model="ProgramModel"  
            :Input="ChangeDropDownPrograms"
            :CustomLabel="customLabelNameCode"/>
        </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12">
           <MdSelect
              v-bind:Label="$t('Shared.Building')"
              v-bind:Options="BuildingOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="BuildingModel"                       
              v-bind:Multiple="false"
              :Input="ChangeBuilding"
            />
        </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12">
           <MdSelect
              v-bind:Label="'Mode'"
              v-bind:Options="ModeOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="ModeModel"                       
              v-bind:Multiple="false"
              :Input="ChangeMode"
            />
        </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12">
           <MdSelect
              v-bind:Label="'Type'"
              v-bind:Options="TypeOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="TypeModel"                       
              v-bind:Multiple="false"
              :Input="ChangeType"
            />
        </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12">
           <MdSelect
              v-bind:Label="'Order By'"
              v-bind:Options="OrderByOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="OrderByModel"                       
              v-bind:Multiple="false"
              :Input="ChangeOrderBy"
            />
        </b-col>
        </b-row>
        <b-row v-if="showDetail">
          <b-col lg="6" md="6" sm="6">
           <MdEdit 
            v-bind:Label="'Start Date'"
            v-bind:TypeProp="'date'" 
            v-bind:Name="'StartDateDetail'"
            v-model="StartDateDetail"
            v-bind:Min="'1899-12-30'"
            v-bind:Max="'2200-12-31'"
            v-on:change="StartDateDetailChange($event)">                                     
          </MdEdit>
        </b-col>
        <b-col lg="6" md="6" sm="6">
           <MdEdit 
            v-bind:Label="'End Date'"
            v-bind:TypeProp="'date'" 
            v-bind:Name="'EndDateDetail'"
            v-model="EndDateDetail"
            v-bind:Min="'1899-12-30'"
            v-bind:Max="'2200-12-31'"
            v-on:change="EndDateDetailChange($event)">                                     
          </MdEdit>
        </b-col>
        </b-row>
        <b-row v-else>
          <b-col lg="12" md="12" sm="12">
           <MdEdit 
            v-bind:Label="'Start Date'"
            v-bind:TypeProp="'date'" 
            v-bind:Name="'StartDate'"
            v-model="StartDate"
            v-bind:Min="'1899-12-30'"
            v-bind:Max="'2200-12-31'"
            v-on:change="StartDateChange($event)"
            v-bind:isValid="this.isStartDateValid">                                     
          </MdEdit>
        </b-col>
        </b-row>
       </b-modal>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="'Pre-Printed MARS Report'"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
        :wrapper-attr="popupAttributes"
      >
        <ReportViewer
          ref="PrePrintedMARSRep"
          :ReportName="showDetail ? 'PrePrintedMARSRep' : 'PrePrintedMARSSummaryRep'"
          :ReportTitle="$t('PatientMedications.ReportMedications')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import EnumService from "@/services/enum.service";
    import PatientService from '@/services/patient.service'
    import ClinicalService from '@/services/clinical.service'
    import AdmissionService from '@/services/admission.service'
    import Utils from '@/common/utils'

    export default Vue.extend({
        name: "PrePrintedMARSRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          patientCode: String,
          recNo: String,
        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                reportParams: [],
                popupAttributes: {
                  id: 'modalPrePrintedMARSRep'
                },
                StatusOptions: EnumService.MedicationStatusReport,
                status : { value: 'ALL', text: 'All' },
                PatientsList:[],
                ProgramList:[],
                BuildingOptions: [],
                ModeOptions: [
                  {"name": "All", "code":""},
                  {"name": "TIMED", "code":"TIMED"},
                  {"name": "STAT", "code":"STAT"},
                  {"name": "PRN", "code":"PRN"}
                ],
                TypeOptions: [
                  {"name": "Detail", "code":"detail"},
                  {"name": "Weekly Summnary (7 Days)", "code":"7days"},
                  {"name": "Weekly Summnary (14 Days)", "code":"14days"},
                ],
                OrderByOptions: [
                  {"name": "Drug Name", "code":"drugname"},
                  {"name": "Active Ing.", "code":"activeing"},
                  {"name": "Issueddate", "code":"issueddate"},
                ],
                PatientCodeModel:'',
                ProgramModel:'',
                BuildingModel: '',
                StartDateDetail: '',
                EndDateDetail: '',
                ModeModel: {"name": "All", "code":""},
                TypeModel: {"name": "Weekly Summnary (7 Days)", "code":"7days"},
                OrderByModel: {"name": "Drug Name", "code":"drugname"},
                StartDate: Utils.formatterDate(Date(), "LLLL"),

                params: {
                  "ProgramCodeList": [],
                  "PatientCodeList": [],
                  "BuildingCodeList": [],
                  "Mode": '',
                  "DateFrom":'',
                  "DateTo": '',
                  "TimeFrom": '',
                  "TimeTo": '',
                  "OrderBy":'drugname'
                },

                fullParam: {
                  PageSize:0,
                  PageNumber:0
                },
                isStartDateValid: true,
                showDetail: false,
            }
        },
        
        methods: {

            customLabelNameCode ({ name, code }) {
              return `${name} – ${code}`
            },

            customLabelPatients ({ patientName, patientcode }) {
              return `${patientName} – ${patientcode}`
            },

            getItemsByComma(values, field) {
              let len = values.length;
              let valuesSeparated = [];
              if (len > 0){
                var i = 0;
                values.forEach(function(e) {   
                if(i < len-1){
                  valuesSeparated += e[field]+",";
                }else{
                  valuesSeparated += e[field];
                }
                i++;                    
                });
                return valuesSeparated;
              }else{
                return [];
              }
            },

            StartDateDetailChange(value) {
              this.params.DateFrom = Utils.formatDateTime(value)             
             },

            EndDateDetailChange(value) {
               this.params.DateTo = Utils.formatDateTime(value)  
             },

            ChangeDropDownPatients(values) {
              this.params.PatientCodeList = this.getItemsByComma(values, 'patientcode')
            },

            ChangeDropDownPrograms(values) {
              this.params.ProgramCodeList = this.getItemsByComma(values, 'code')
            },

            ChangeBuilding(item) {
              this.params.BuildingCodeList = this.getItemsByComma(item, 'code')
            },

            ChangeMode(item) {
              this.params.Mode = item.code
            },

            ChangeType(item) {
               this.showDetail = item.code == 'detail' ? true : false
              if (this.showDetail) {
                this.setDefaultDateTime()
              }
            },

            ChangeOrderBy(item) {
              this.params.OrderBy = item.code
            },

            StartDateChange(value) {
              this.params.StartDate= value
            },

            setDefaultDateTime() {
              let currDate = new Date();

              currDate.setHours(0, 0, 0);
              this.params.DateFrom = Utils.formatDateTime(currDate)
              
              currDate.setHours(23, 59, 0);
              this.params.DateTo = Utils.formatDateTime(currDate)

              currDate.setFullYear(1899, 11, 30);

              this.params.TimeTo = Utils.formatDateTime(currDate)
              
              currDate.setHours(0, 0, 0);              
              this.params.TimeFrom = Utils.formatDateTime(currDate)           

              this.StartDateDetail = Utils.formatterNowToDate()
              this.EndDateDetail = Utils.formatterNowToDate()
            },

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
              this.isParamVisible = false;
            },

            onClickShowReport() {
              this.isParamVisible = false
              this.reportParams = []
                          

              this.reportParams.push({ paramName: 'DateFrom', paramValue: this.params.DateFrom})
              this.reportParams.push({ paramName: 'DateTo', paramValue: this.params.DateTo})
              this.reportParams.push({ paramName: 'TimeFrom', paramValue: this.params.TimeFrom})
              this.reportParams.push({ paramName: 'TimeTo', paramValue: this.params.TimeTo})

              this.reportParams.push({ paramName: 'DateFromStr', paramValue: Utils.formatterDate(this.params.DateFrom)})
              this.reportParams.push({ paramName: 'DateToStr', paramValue:  Utils.formatterDate(this.params.DateTo)})
              this.reportParams.push({ paramName: 'TimeFromStr', paramValue: Utils.formatTime(this.params.TimeFrom)})
              this.reportParams.push({ paramName: 'TimeToStr', paramValue: Utils.formatTime(this.params.TimeTo)})
              
              this.reportParams.push({ paramName: 'ProgramCodeList', paramValue: this.params.ProgramCodeList})
              this.reportParams.push({ paramName: 'PatientCodeList', paramValue: this.params.PatientCodeList})
              this.reportParams.push({ paramName: 'BuildingCodeList', paramValue: this.params.BuildingCodeList})
              this.reportParams.push({ paramName: 'Mode', paramValue: this.params.Mode})

              this.reportParams.push({ paramName: 'OrderBy', paramValue: this.params.OrderBy})
              
              this.isReportVisible = true
              this.$refs.PrePrintedMARSRep.buildDocument(this.reportParams)
            },

            getPatients() {              
                PatientService.getAll(this.fullParam)
                .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.PatientsList = response.data; 
                  this.PatientsList.forEach(function(element) {
                      element.patientName = element.firstname + " " + element.lastname;   
                    });
                  }      
                  this.$emit('load', false);
                })
                .catch(error => {
                  this.$emit('load', false);
                  if (!error.response) {
                      // network error
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  } else {
                      this.showMessage(this.$tc('Msg.Error'),error,"error");
                  }
                });
            },

            getPrograms() {
              ClinicalService.getPrograms()
                .then((response) => {
                     if(response.status == '200' && response.data && response.data.length > 0){                        
                       this.ProgramList = response.data;                                          
                     }               
                })
                .catch((error) => {
                    /*if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }*/
                    this.showResponseErrorMessage(error);
                });  
            },

            getBuildings(){
              AdmissionService.getBuildings()
                .then((response) => {
                    if(response.status == '200'){
                        this.BuildingOptions = response.data; 
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
            },
        },
        
        mounted () {
          this.getPatients();
          this.getPrograms();
          this.getBuildings()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
